var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.showInvoiceModal
        },
        on: {
          close: _vm.closeInvoiceModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" " + _vm._s(_vm.title) + " ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _vm._v(
                  " Would you like proceed to invoice #" +
                    _vm._s(_vm.invoiceId) +
                    "? "
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    on: {
                      click: _vm.viewInvoice
                    }
                  },
                  [_vm._v("View Invoice")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeInvoiceModal
                    }
                  },
                  [_vm._v("Close")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }